import { RangeFilter } from '@dofleini/query-builder';
import { differenceInDays, endOfDay, startOfDay } from 'date-fns';
import { DATES_OPTIONS_ENUM, DATES_OPTIONS_VALUES } from '@dfl/mui-admin-layout';
import { INTERVAL } from 'components/libs/analytic/hooks/useInterval';

export const useParseDateFilter = (value: string, field: string, mapDate = (v: Date, x: string) => v) => {
  const values = Object.values(DATES_OPTIONS_ENUM);
  const existFilter = values.find((el) => el === value);
  if (existFilter || !value) {
    // @ts-ignore
    const elements = DATES_OPTIONS_VALUES[value];
    if (!!elements?.[0] && !!elements?.[1]) {
      return new RangeFilter({
        field,
        isDate: true,
        from: mapDate(elements?.[0], 'from'),
        to: mapDate(elements?.[1], 'to'),
        type: 'RANGE',
      });
    }
    return {};
  } else {
    const elements = stringToRange(value);
    if (!!elements?.[0] && !!elements?.[1]) {
      return new RangeFilter({
        field,
        isDate: true,
        from: mapDate(elements?.[0], 'from'),
        to: mapDate(elements?.[1], 'to'),
        type: 'RANGE',
      });
    }
    return {};
  }
};

export const useDateFilterValue = (value: string, mapDate = (v: Date, x: string) => v) => {
  const values = Object.values(DATES_OPTIONS_ENUM);
  const existFilter = values.find((el) => el === value);
  if (existFilter || !value) {
    // @ts-ignore
    const elements = DATES_OPTIONS_VALUES[value];
    if (!!elements?.[0] && !!elements?.[1]) {
      // @ts-ignore
      return elements?.map((e, index) => mapDate(e, index === 0 ? 'from' : 'to'));
    }
    return [];
  } else {
    const elements = stringToRange(value);
    if (!!elements?.[0] && !!elements?.[1]) {
      return elements?.map((e, index) => mapDate(e, index === 0 ? 'from' : 'to'));
    }
    return [];
  }
};

export const useGetIntervalByValue = (value: string) => {
  switch (value) {
    case DATES_OPTIONS_ENUM.TODAY:
      return INTERVAL.hourly;
    case DATES_OPTIONS_ENUM.LAST_TWELVE_MONTHS:
    case DATES_OPTIONS_ENUM.THIS_YEAR:
      return INTERVAL.monthly;
    default: {
      const range = stringToRange(value);
      if (range) {
        const dif = differenceInDays(range[1], range[0]);
        if (!dif || dif < 6) return INTERVAL.hourly;
        if (dif && dif >= 365) return INTERVAL.monthly;
      }
      return INTERVAL.daily;
    }
  }
};

export const stringToRange = (value: string): Date[] | undefined => {
  if (!value) return undefined;
  const range = value?.split('_');
  if (range?.length === 1 && value in DATES_OPTIONS_VALUES) {
    return DATES_OPTIONS_VALUES[value as keyof typeof DATES_OPTIONS_VALUES];
  }
  return range?.map((d, index) => {
    if (index === 0) return startOfDay(new Date(d));
    return endOfDay(new Date(d));
  });
};
